import { nodeDefinitions } from 'graphql-relay';

// Models

const { nodeInterface, nodeField } = nodeDefinitions(
  () => ({}),
  (obj) => {
    const modelType = obj.modelType;
    const gqlType = window[modelType + 'GQLType'];
    return gqlType;
  }
);

module.exports = {
  nodeInterface,
  nodeField
};
